import { Component } from '@angular/core';
import { EnergyInterfaceListSkeleton } from '../energy-interface-list-skeleton/energy-interface-list-skeleton';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-energy-interface-location-skeleton',
  imports: [EnergyInterfaceListSkeleton, Skeleton],
  templateUrl: './energy-interface-location-skeleton.html',
})
export class EnergyInterfaceLocationSkeleton {}
